import React from "react";
import CoverBanner from "components/Spotlight/CoverBanner";
import MyDefaultCoverPhoto from "site_media/images/DefaultCoverYosemite.png";
import AxiosConfig from "axiosConfig";
import { FaPencilAlt } from "react-icons/fa";

class ProfileInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      profile_pic:
        "https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885_1280.jpg",
      cover_pic: "",
      age: "",
      city: "",
      state: "",
    };

    /**
     * This wasn't working anymore so it shows the MyDefaultCoverPhoto instead.
     * "https://cdn.pixabay.com/photo/2016/10/18/21/22/california-1751455_1280.jpg"
     */
  }

  componentDidMount() {
    this.fetchProfileInfo(this);
  }

  fetchProfileInfo(obj) {
    AxiosConfig.get(`profile/details/`)
      .then(function (response) {
        obj.setProfileInfo(response);
      })
      .catch(function (error) {});
  }

  setProfileInfo(response) {
    let dob = response.data["dob"];
    let full_name = response.data["full_name"];
    let address = response.data["address"];
    let profile_pic = response.data["profile_pic"];
    let cover_pic = response.data["cover_pic"];
    this.setState((prevState) => ({
      dob: dob,
      full_name: full_name,
      address: address,
      profile_pic: profile_pic,
      cover_pic: cover_pic,
    }));
  }

  getAge(DOB) {
    var today = new Date();
    var birthDate = new Date(DOB);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age = age - 1;
    }

    return age;
  }

  onImgChange(event) {
    // event.preventDefault();
    const files = URL.createObjectURL(event.target.files[0]);
    this.setState({ cover_pic: files });
    let form_data = new FormData();
    form_data.append("cover_pic", this.state.cover_pic);

    return AxiosConfig.put("profile/details/", form_data, {
      headers: { "content-type": "multipart/form-data" },
    })
      .then()
      .catch();
  }

  render() {
    return (
      <div className="mb-15 profileInfo edit-profile-option">
        <CoverBanner
          cover={this.state.cover_pic || MyDefaultCoverPhoto}
          profile={this.state.profile_pic}
        />
        <a href={"/account"} className="edit-account">
          <FaPencilAlt size={12} style={{ fill: "#ff431b" }} />
        </a>

        <div className="profileDetails">
          <h3 className="break-text">{this.state.full_name}</h3>
          <h5>Age : {this.getAge(this.state.dob)}</h5>
          {/* <h5>{this.state.address}</h5> */}
        </div>
      </div>
    );
  }
}

export default ProfileInfo;
